export default {
  methods: {
    render_main(data,categoryName) {
      let option = {
          title: {
              text: `${data.categoryNum}个品类${data.total}个产品`,
              top: 0,
              right: 0,
              textStyle: {
                fontSize: 12,
                color: '#777',
                fontWeight: 'normal'
              }
          },
          tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross',
                  crossStyle: {
                      color: '#999'
                  }
              }
          },
          legend: {
              data: ['销量', '产品数', '产品均销量'],
              top: 20
          },
          grid: {
            left: 50,
            bottom: 30,
            right: 50
          },
          xAxis: [
              {
                  type: 'category',
                  data: data.productAnalyzeVo.map(v=>v.category),
                  axisPointer: {
                      type: 'shadow'
                  },
                  axisTick: { show: false },
                  axisLabel: {
                    color: 'rgb(135,139,160)',
                    interval: 0,
                    formatter: value =>{
                      if(value.length > 4) {
                        return String(value).substring(0,4)+'...'
                      }else{
                        return value
                      }
                    }
                  },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  }
              }
          ],
          yAxis: [
              {    
                  name: '销量',
                  type: 'value',
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              },
              {
                  name: '产品数',
                  type: 'value',
                  axisLabel: {
                    color: 'rgb(135,139,160)'
                  },
                  minInterval: 1,
                  axisTick: { show: false },
                  axisLine: {
                    lineStyle: {
                      color: '#e2e2e2'
                    }
                  },
                  splitLine: { show: false }
              }
          ],
          // dataset: {
          //   source: data,
          //   dimensions: ['category', 'buyNum', 'num']
          // },
          series: [
              {   
                  name: '销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.productAnalyzeVo.map(v=>v.buyNum),
                  itemStyle: {
                    color: 'rgb(250,137,0)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#ffffff',
                      borderColor: '#00A6ED',
                      borderWidth: 0
                    }
                  },
                  selectedMode: true
              },
              {
                  name: '产品均销量',
                  type: 'line',
                  yAxisIndex: 0,
                  data: data.productAnalyzeVo.map(v=>v.avgBuyNum),
                  itemStyle: {
                    color: '#00A6ED'
                  }
              },
              {
                  name: '产品数',
                  type: 'bar',
                  yAxisIndex: 1,
                  data: data.productAnalyzeVo.map(v=>v.num),
                  itemStyle: {
                    color: 'rgb(11,183,142)',
                    borderRadius: [5,5,0,0]
                  },
                  barWidth: 18,
                  // showBackground: true,
                  label: {
                    show: true,
                    position: 'top'
                  },
                  select: {
                    label: {
                      show: true
                    },
                    itemStyle: {
                      color: '#00A6ED',
                      borderColor: '#00A6ED'
                    }
                  },
                  selectedMode: true
              }
          ],
          animationDelay: function(idx) {
            return 50*idx
          }
      };
      let $instance = this.$echarts.init(this.$refs['main']);
      $instance.setOption(option);
      $instance.on('click',params => {
          console.log(params);
          this.$nextTick(_=>{
            this.active = '1'
            setTimeout(() => {
              this.$refs['classify'].handleCategoryChange(params.name)
            }, 100);
          })
          
          $instance.dispatchAction({
            type: 'select',
            seriesIndex: params.seriesIndex ? 0 : 1,
            dataIndex: params.dataIndex
          });
      });
      $instance.dispatchAction({
        type: 'select',
        seriesIndex: 2,
        name: categoryName || '沙发'
      });
      // $instance.dispatchAction({
      //   type: 'legendInverseSelect'
      // });
      // $instance.dispatchAction({
      //   type: 'legendSelect',
      //   name: '产品数'
      // });
    }
  }
}